import Swal from 'sweetalert2';

/**
 * Modern replacement for window.confirm() using SweetAlert2
 * Returns a Promise that resolves to true if confirmed, false if cancelled
 */
const confirm = async (message, options = {}) => {
  const {
    title = 'Bekreft handling',
    confirmButtonText = 'Ja',
    cancelButtonText = 'Avbryt',
    icon = 'warning',
    ...otherOptions
  } = options;

  const result = await Swal.fire({
    title,
    text: message,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor: '#50E3C2', // Infovegg teal
    cancelButtonColor: '#6c757d',
    background: '#2a3142',
    color: '#fff',
    customClass: {
      popup: 'swal-dark',
      confirmButton: 'swal-confirm-button',
      cancelButton: 'swal-cancel-button'
    },
    ...otherOptions
  });

  return result.isConfirmed;
};

/**
 * Destructive action confirmation (for delete actions)
 */
confirm.danger = async (message, options = {}) => {
  return confirm(message, {
    icon: 'error',
    confirmButtonText: 'Slett',
    title: 'Bekreft sletting',
    confirmButtonColor: '#dc3545',
    ...options
  });
};

/**
 * Warning confirmation
 */
confirm.warning = async (message, options = {}) => {
  return confirm(message, {
    icon: 'warning',
    title: 'Advarsel',
    ...options
  });
};

/**
 * Info confirmation
 */
confirm.info = async (message, options = {}) => {
  return confirm(message, {
    icon: 'info',
    title: 'Informasjon',
    ...options
  });
};

export default confirm;
